import React from 'react';
import { Nullable, SelectOption } from 'global';
import { useFormContext, useWatch } from 'react-hook-form';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';
import { FinanceDetails } from './FinanceDetails';
import { FinanceFormValues } from '../types';
import { InitializeWorkflow } from './InitializeWorkflow';

export const Finance = ({
  financeAmount,
  netInvoiceAmount,
  maxApprovalAmount,
  isFPOptionsLoading,
  financeProgramOptions,
  onFetchFinanceProgram,
}: {
  financeAmount: number;
  netInvoiceAmount: number;
  maxApprovalAmount: number;
  isFPOptionsLoading: boolean;
  financeProgramOptions: SelectOption[];
  onFetchFinanceProgram: (programId: string) => Promise<Partial<FinanceFormValues['financeQuote']>>;
}) => {
  const { control } = useFormContext<FinanceFormValues>();

  const createProposalWithExistingProgram = useWatch({
    control,
    name: 'financeQuote.createProposalWithExistingProgram',
  });

  const isShowDetailsFields = createProposalWithExistingProgram !== null;

  return (
    <>
      <InitializeWorkflow
        submissions={[]}
        submissionsOptions={[]}
        financeAmount={financeAmount}
        maxApprovalAmount={maxApprovalAmount}
      />

      <RenderWithCondition condition={isShowDetailsFields}>
        <FinanceDetails
          netInvoiceAmount={netInvoiceAmount}
          isFPOptionsLoading={isFPOptionsLoading}
          onFetchFinanceProgram={onFetchFinanceProgram}
          financeProgramOptions={financeProgramOptions}
        />
      </RenderWithCondition>
    </>
  );
};
